import { StringMap } from '@mecontrol/common';
import { ME } from './globals';
import { assign } from './object';

let _strings: Record<string, StringMap> = {};
let _currentLang: string;

/**
 * Gets the language to be used for getString.
 */
function getCurrentLang(): string {
    // return Config.mkt by default if the internal market has not been set externally
    // defaults to 'en-US' if neither of them is defined.
    return (_currentLang || ME.Config.mkt || "en-US").toLowerCase();
}

/**
 * Sets the language to be used for getString.
 * @param newCurrentLang The new language to set to
 */
export function setCurrentLang(newCurrentLang: string): void {
    _currentLang = newCurrentLang.toLowerCase();
}

/**
 * Adds new string resources
 * @param curLang The culture paired with the strings
 * @param newStrings The new strings to be added
 */
export function addStrings(curLang: string, newStrings: StringMap): void {
    curLang = curLang.toLowerCase();
    _strings[curLang] = _strings[curLang] || {};
    assign(_strings[curLang], newStrings);
}

/**
 * Gets an unencoded string resource
 * @param stringId The string value for the given string id
 * @returns The string resource
 */
export function getString(stringId: string): string {
    let lang = getCurrentLang();

    // always fetch the current language in case the app sets it to something else after page loading
    return _strings[lang] && _strings[lang][stringId] || `ERROR: ${stringId}`;
}
